import { EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { IdTokenClaims } from "lib/auth";

export function getIdTokenClaims(event: EventMessage, loginSuccess: boolean) {
  return loginSuccess ?
    (event.payload as AuthenticationResult | undefined)?.idTokenClaims as IdTokenClaims :
    undefined;
}
